var __getOwnPropNames = Object.getOwnPropertyNames;
var __commonJS = (cb, mod) => function __require() {
  try {
    return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
  } catch (e) {
    throw mod = 0, e;
  }
};

// server/services/philips-hue/lib/utils/consts.js
var require_consts = __commonJS({
  "server/services/philips-hue/lib/utils/consts.js"(exports, module) {
    var BRIDGE_MODEL = "philips-hue-bridge";
    var BRIDGE_EXTERNAL_ID_BASE = "philips-hue:bridge";
    var HUE_APP_NAME = "Gladys";
    var HUE_DEVICE_NAME = "Gladys Instance";
    var BRIDGE_IP_ADDRESS = "BRIDGE_IP_ADDRESS";
    var BRIDGE_USERNAME = "BRIDGE_USERNAME";
    var BRIDGE_SERIAL_NUMBER = "BRIDGE_SERIAL_NUMBER";
    var LIGHT_MODEL = "philips-hue-light";
    var LIGHT_EXTERNAL_ID_BASE = "philips-hue-light";
    module.exports = {
      BRIDGE_MODEL,
      BRIDGE_EXTERNAL_ID_BASE,
      HUE_APP_NAME,
      HUE_DEVICE_NAME,
      BRIDGE_IP_ADDRESS,
      BRIDGE_USERNAME,
      BRIDGE_SERIAL_NUMBER,
      LIGHT_MODEL,
      LIGHT_EXTERNAL_ID_BASE
    };
  }
});
const __cjsModule = require_consts();
export default __cjsModule;
export const BRIDGE_MODEL = __cjsModule.BRIDGE_MODEL;
export const BRIDGE_EXTERNAL_ID_BASE = __cjsModule.BRIDGE_EXTERNAL_ID_BASE;
export const HUE_APP_NAME = __cjsModule.HUE_APP_NAME;
export const HUE_DEVICE_NAME = __cjsModule.HUE_DEVICE_NAME;
export const BRIDGE_IP_ADDRESS = __cjsModule.BRIDGE_IP_ADDRESS;
export const BRIDGE_USERNAME = __cjsModule.BRIDGE_USERNAME;
export const BRIDGE_SERIAL_NUMBER = __cjsModule.BRIDGE_SERIAL_NUMBER;
export const LIGHT_MODEL = __cjsModule.LIGHT_MODEL;
export const LIGHT_EXTERNAL_ID_BASE = __cjsModule.LIGHT_EXTERNAL_ID_BASE;
